































































import commons from "@/common/store/modules/commons";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import { Prop, Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";

@Component({
  components: {
    PointNotation
  }
})
export default class D03Details extends Vue {
  @Prop({ type: Object, required: false }) points!: any;

  get unit() {
    return commons?.OrgPageSpecific?.point_name;
  }

  //unit = commons.unit;
}
